<template>
  <div>
    <vue-headful
        title="Vistuð leitarskilyrði | bilaskra.is"
        description="Vistuð leitarskilyrði | bilaskra.is"
    />
    <div class="notifications-wrap container">
      <div class="notifications-wrap__inner">
        <div>
          <h1 class="notifications-title">Vistuð leitarskilyrði</h1>
          <p class="notifications-description">
            Þegar verð lækkar eða ný gerð/útfærsla samkvæmt þessum leitarskilyrðum
            kemur á markað færð þú tilkynningu með tölvupósti.
          </p>
        </div>

        <div v-for="(v, i) in getSearches" :key="i" class="mt-6">
          <h2 v-text="v.title"></h2>
          <notification-item
              v-for="d in v.data"
              :d="d"
              :keyItem="d.id"
              :lib="lib"
              :key="d.id"
          />
        </div>
      </div>
    </div>
    <Footer class="notifications-footer" v-if="isIosApp" />
  </div>
</template>

<script>
import NotificationItem from "../components/NotificationItem.vue";
import Footer from "@/components/Footer";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  data: function () {
    return {};
  },
  methods: {
    ...mapMutations({
      setPopup: "SET_POPUP",
    }),
    ...mapActions({
      getNotification: "GET_NOTIFICATIONS",
      getLib: "GET_LIB",
      getProfile: "GET_PROFILE",
    }),
  },
  components: {
    "notification-item": NotificationItem,
    Footer
  },
  computed: {
    ...mapGetters(["notifications", "isIosApp"]),
    old_car() {
      return this.notifications.old_car;
    },
    new_car() {
      return this.notifications.new_car.filter((e) => e.type_id == 3);
    },
    stock_car() {
      return this.notifications.new_car.filter((e) => e.type_id == 7);
    },
    lib() {
      return this.$store.state.lib;
    },
    getSearches() {
      let res = [];
      if (this.new_car.length > 0) {
        res.push({
          title: "Vistuð leit nýja bíla",
          data: this.new_car,
        });
      }

      if (this.stock_car.length > 0) {
        res.push({
          title: "Vistuð leit kjarabíla",
          data: this.stock_car,
        });
      }

      if (this.old_car.length > 0) {
        res.push({
          title: "Vistuð leit notaða bíla",
          data: this.old_car,
        });
      }

      return res;
    },
  },
  mounted: function () {
    this.getLib();
    this.getProfile().then(() => {
      if (!this.$store.state.profile.user) {
        this.setPopup("sign-in");
      }
    });

    this.getNotification();
    //.then(response => {
    // console.log('response', this.$store.state.notifications);
    // if (!!response.data) {
    //   this.old_car = response.data.old_car;
    //   this.new_car = response.data.new_car.filter(e => {
    //     return e.type_id == 3
    //   });
    //
    //   this.stock_car = response.data.new_car.filter(e => {
    //     return e.type_id == 7
    //   });
    //
    //   this.lib = response.data.lib;
    //
    //   var data = this.lib.brands;
    //   for (var k in data) {
    //     data[k].name = data[k].company;
    //   }
    // }
    //},
    // response => {
    //   this.error = response;
    // }
    //);
  },
};
</script>
